import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";

var _update = require("immutability-helper");

import { BoolMust } from "./query_dsl";
import { Utils } from "../support/Utils";

var omitBy = require("lodash/omitBy");

var omit = require("lodash/omit");

var values = require("lodash/values");

var pick = require("lodash/pick");

var merge = require("lodash/merge");

var isUndefined = require("lodash/isUndefined");

export var ImmutableQuery =
/*#__PURE__*/
function () {
  function ImmutableQuery() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ImmutableQuery.defaultIndex;

    _classCallCheck(this, ImmutableQuery);

    this.index = index;
    this.buildQuery();
  }

  _createClass(ImmutableQuery, [{
    key: "buildQuery",
    value: function buildQuery() {
      var query = {};

      if (this.index.queries.length > 0) {
        query.query = BoolMust(this.index.queries);
      }

      if (this.index.filters.length > 0) {
        query.post_filter = BoolMust(this.index.filters);
      }

      query.aggs = this.index.aggs;
      query.size = this.index.size;
      query.from = this.index.from;
      query.sort = this.index.sort;
      query.highlight = this.index.highlight;
      query.suggest = this.index.suggest;

      if (this.index._source) {
        query._source = this.index._source;
      }

      this.query = omitBy(query, isUndefined);
    }
  }, {
    key: "hasFilters",
    value: function hasFilters() {
      return this.index.filters.length > 0;
    }
  }, {
    key: "hasFiltersOrQuery",
    value: function hasFiltersOrQuery() {
      return this.index.queries.length + this.index.filters.length > 0 || !!this.index.sort;
    }
  }, {
    key: "addQuery",
    value: function addQuery(query) {
      if (!query) {
        return this;
      }

      return this.update({
        queries: {
          $push: [query]
        }
      });
    }
  }, {
    key: "setQueryString",
    value: function setQueryString(queryString) {
      return this.update({
        $merge: {
          queryString: queryString
        }
      });
    }
  }, {
    key: "getQueryString",
    value: function getQueryString() {
      return this.index.queryString;
    }
  }, {
    key: "addSelectedFilter",
    value: function addSelectedFilter(selectedFilter) {
      return this.addSelectedFilters([selectedFilter]);
    }
  }, {
    key: "addSelectedFilters",
    value: function addSelectedFilters(selectedFilters) {
      return this.update({
        selectedFilters: {
          $push: selectedFilters
        }
      });
    }
  }, {
    key: "getSelectedFilters",
    value: function getSelectedFilters() {
      return this.index.selectedFilters;
    }
  }, {
    key: "addAnonymousFilter",
    value: function addAnonymousFilter(bool) {
      return this.addFilter(Utils.guid(), bool);
    }
  }, {
    key: "addFilter",
    value: function addFilter(key, filter) {
      return this.update({
        filters: {
          $push: [filter]
        },
        filtersMap: {
          $merge: _defineProperty({}, key, filter)
        }
      });
    }
  }, {
    key: "setAggs",
    value: function setAggs(aggs) {
      return this.deepUpdate("aggs", aggs);
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.getFiltersWithoutKeys(keys);
    }
  }, {
    key: "_getFilters",
    value: function _getFilters(keys, method) {
      keys = [].concat(keys);
      var filters = values(method(this.index.filtersMap || {}, keys));
      return BoolMust(filters);
    }
  }, {
    key: "getFiltersWithKeys",
    value: function getFiltersWithKeys(keys) {
      return this._getFilters(keys, pick);
    }
  }, {
    key: "getFiltersWithoutKeys",
    value: function getFiltersWithoutKeys(keys) {
      return this._getFilters(keys, omit);
    }
  }, {
    key: "setSize",
    value: function setSize(size) {
      return this.update({
        $merge: {
          size: size
        }
      });
    }
  }, {
    key: "setSort",
    value: function setSort(sort) {
      return this.update({
        $merge: {
          sort: sort
        }
      });
    }
  }, {
    key: "setSource",
    value: function setSource(_source) {
      return this.update({
        $merge: {
          _source: _source
        }
      });
    }
  }, {
    key: "setHighlight",
    value: function setHighlight(highlight) {
      return this.deepUpdate("highlight", highlight);
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return this.query.size;
    }
  }, {
    key: "setFrom",
    value: function setFrom(from) {
      return this.update({
        $merge: {
          from: from
        }
      });
    }
  }, {
    key: "getFrom",
    value: function getFrom() {
      return this.query.from;
    }
  }, {
    key: "getPage",
    value: function getPage() {
      return 1 + Math.floor((this.getFrom() || 0) / (this.getSize() || 10));
    }
  }, {
    key: "deepUpdate",
    value: function deepUpdate(key, ob) {
      return this.update({
        $merge: _defineProperty({}, key, merge({}, this.index[key] || {}, ob))
      });
    }
  }, {
    key: "setSuggestions",
    value: function setSuggestions(suggestions) {
      return this.update({
        $merge: {
          suggest: suggestions
        }
      });
    }
  }, {
    key: "update",
    value: function update(updateDef) {
      return new ImmutableQuery(_update(this.index, updateDef));
    }
  }, {
    key: "getJSON",
    value: function getJSON() {
      return this.query;
    }
  }, {
    key: "printJSON",
    value: function printJSON() {
      console.log(JSON.stringify(this.getJSON(), null, 2));
    }
  }]);

  return ImmutableQuery;
}();
ImmutableQuery.defaultIndex = {
  queryString: "",
  filtersMap: {},
  selectedFilters: [],
  queries: [],
  filters: [],
  _source: null,
  size: 0
};